module.exports = __webpack_public_path__ + "img/android4.d7a4b7e4.jpg";